import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "button", "modal"];
  static values = {
    certId: Number,
    status: String
  };

  async uploadFiles(event) {
    this.buttonTarget.classList.add("disabled");

    const form = this.inputTarget.closest("form");
    const url = form.action;
    const formData = new FormData(form);
    const errMsg = "Error on attachment upload, please try again.";

    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          Accept: "application/json"
        },
        body: formData
      });

      if (response.ok) {
        const data = await response.json();
      this.updateCardStatus(data.html);
        this.updateModalContent(data.html);
      } else {
        this.insertErrorAlert(errMsg);
      }
    } catch (error) {
      this.insertErrorAlert(errMsg);
    } finally {
      this.buttonTarget.classList.remove("disabled");
    }
  }


  // Approve/Deny actions
  async updateStatus(event) {
    event.preventDefault();
    const status = event.currentTarget.dataset.certificationFileUploadStatusValue;
    const form = event.currentTarget.closest("form");

    const formData = new FormData(form);
    formData.append("provider_certification[status]", status);

    await this.submitForm(form, formData);
  }

  async updateExpiration(event) {
    const form = event.target.closest("form");
    const formData = new FormData(form);

    await this.submitForm(form, formData);
  }

  async submitForm(form, formData = null) {
    const url = form.action;
    const errMsg = "Error updating certification, please try again.";

    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          Accept: "application/json"
        },
        body: formData || new FormData(form)
      });

      if (response.ok) {
        const data = await response.json();
        this.updateCardStatus(data.html);
        this.updateModalContent(data.html);
      } else {
        this.insertErrorAlert(errMsg);
      }
    } catch (error) {
      this.insertErrorAlert(errMsg);
    }
  }

  updateModalContent(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const newModalContent = tempDiv.querySelector(".modal-content");
    const modal = document.querySelector(`.provider-certification-modal[data-id="${this.certIdValue}"]`);
    const modalContent = modal.querySelector('.modal-content');

    if (modal && modalContent && newModalContent) {
      modalContent.replaceWith(newModalContent);

      const alert = this.createSuccessAlert();
      modal.querySelector(".modal-body").appendChild(alert);
      setTimeout(() => alert.remove(), 2000);

      document.dispatchEvent(new Event("DOMContentLoaded", { bubbles: true, cancelable: true }));
    } else {
      this.insertErrorAlert("Failed to update modal content.");
    }
  }

  updateCardStatus(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const updatedCard = tempDiv.querySelector(`#provider-certification-${this.certIdValue}-card-body`);
    const existingCard = document.querySelector(`#provider-certification-${this.certIdValue}-card-body`);

    if (updatedCard && existingCard) {
      existingCard.replaceWith(updatedCard);
    }
  }

  createSuccessAlert() {
    const alert = document.createElement("div");
    alert.className = "alert alert-success";
    alert.textContent = "Successfully Updated";
    return alert;
  }

  createErrorAlert(msg) {
    const alert = document.createElement("div");
    alert.className = "alert alert-danger";
    alert.textContent = msg || "Error, please try again.";
    return alert;
  }

  insertErrorAlert(msg) {
    const errorAlert = this.createErrorAlert(msg);
    this.modalTarget.querySelector(".modal-body").appendChild(errorAlert);
    setTimeout(() => errorAlert.remove(), 2000);
  }

  connect() {}
}
